import React from 'react';
import { Tree } from 'antd';
import {
  arrayOf, func, number, oneOfType, shape, string,
} from 'prop-types';

const STATIC_OFFSET = 14;

const ProductionCycles = ({
  checkedKeys = [],
  setCheckedKeys,
  treeData = [],
  drawerHeight,
}) => {
  const onCheck = (checkedKeysValue) => {
    const filteredCheckedKeysValue = checkedKeysValue.filter((item) => !item.toString().split('-', 1).includes('season'));

    setCheckedKeys(filteredCheckedKeysValue);
  };

  const renderTitle = (node) => {
    if (Object.prototype.hasOwnProperty.call(node, 'year')) {
      return <b>{node.title}</b>;
    }

    return node.title;
  };

  return (
    <div id="production-cycles-top">
      <Tree
        checkable
        multiple
        style={{ minHeight: drawerHeight - STATIC_OFFSET }}
        height={drawerHeight - STATIC_OFFSET}
        defaultExpandAll
        selectable={false}
        onSelect={onCheck}
        onCheck={onCheck}
        checkedKeys={checkedKeys}
        treeData={treeData}
        titleRender={renderTitle}
      />
    </div>
  );
};

ProductionCycles.propTypes = {
  checkedKeys: arrayOf(oneOfType([string, number])),
  setCheckedKeys: func.isRequired,
  treeData: arrayOf(shape({
    title: string,
    key: oneOfType([string, number]),
    children: arrayOf(shape({
      title: string,
      key: oneOfType([string, number]),
    })),
  })),
  drawerHeight: number.isRequired,
};

export default ProductionCycles;
